export default defineNuxtRouteMiddleware(async (to, from) => {
  // console.log('middleware: restore session and user')
  // console.log('checking trailing slash...')
  // if (to.path.endsWith('/') && to.path !== '/') {
  //   console.log('---- removing slahings')
  //   return navigateTo({
  //     path: to.path.slice(0, -1),
  //     query: to.query
  //   }, { replace: true })
  // }
  const visitorSession = useVisitorSession()
  const user = useUser()
  const validSubPathes = {
    add_ticket: true,
    billing: true,
    profile: true,
    settings: true,
    support: true,
    tickets: true,
  } as const

  // return new Promise(navigateTo({
  //   path: `/dashboard/${visitorSession.id}/${to.params.userId}`,
  //   query: to.query
  // }))
  
  try {
    // console.log('starting.')
    await visitorSession.getSession()
    // console.log('visitor email:', visitorSession.email)
    // console.log('to.params.userId is:', to.params.userId)
    // console.log(`isNaN(Number(to.params.userId)), to.params.userId?.includes('@') > 0`, isNaN(Number(to.params.userId)), to.params.userId?.includes('@'))

    const paramsIsValidUserIdOrEmail = !isNaN(Number(to.params.userId)) || (to.params.userId?.includes('@') && to.params.userId?.includes('.'))
    // console.log('isValidUserIdOrEmail:', paramsIsValidUserIdOrEmail)
    // console.log('00000')
    if (!visitorSession.loggedIn) {
      // console.log('visitorSession.loggedIn is false, redirect to /login')
      useFullscreenLoading().close()
      return
      // return navigateTo('/login')
    }
    // console.log('path??', `/dashboard/${visitorSession.id}/${to.params.userId}`)
    // const newDest = {
    //   path: `/dashboard/${visitorSession.id}/${to.params.userId}`,
    //   query: to.query
    // }

    // console.log('newDest 1:', newDest)
    // return newDest

    // // for visits to dashboard, validate sub path and params.
    if (to.name === 'dashboard-userId') {
      // console.log('to.name === "dashboard-userId"', paramsIsValidUserIdOrEmail)
      if (validSubPathes[String(to.params.userId)]) {
        // user is visiting /dashboard/[support|profile|...], redirect to /dashboard/${userId}/support
        // console.log(`redirecting to /dashboard/${visitorSession.id}/${to.params.userId}`)
        const newDest = {
          path: `/dashboard/${visitorSession.id}/${to.params.userId}`,
          query: to.query
        }
        // console.log('newDest 1:', newDest)

        return navigateTo(newDest)
      } else 
      // not a valid subpath, redirect to /dashboard/${visitorSession.id}
        if (!paramsIsValidUserIdOrEmail) {
          // console.log(`to.params.userId is '${String(to.params.userId)}' not a valid subpath, redirecting to /dashboard/${visitorSession.id}`)
          const newDest = {
            path: `/dashboard/${visitorSession.id}`,
            query: to.query
          }
          // console.log('newDest 2:', newDest)
          // return
          return navigateTo(newDest)
        // return {
        //   // name: 'dashboard-userId',
        //   ...to,
        //   params: {
        //     userId: String(visitorSession.id)
        //   }
        // }
        }
      // console.log('subpath checking end.')
    }

    // console.log('22222')


    // determine which user to fetch.
    if (visitorSession.realAdmin) {
      // console.log('is real admin, checking which id to fetch')
      // admin, fetch user by query.asUser
      if (paramsIsValidUserIdOrEmail) {
        // console.log('fetching user by params.userId:', to.params.userId)
        await user.get({ id: String(to.params.userId) })
      } else if (to.query.asUser) {
        // console.log('fetching user by query.asUser:', to.query.asUser)
        await user.get({ id: Number(to.query.asUser) })
      } else {
        // console.log('???? no valid params.userId or query.asUser, use session data as user data')
        user.setUserData(visitorSession.$state as any)
      }
    } else {
      // not admin, skip fetch, always use session data as user data
      // console.log('not admin, skip fetch, use session data as user data')
      user.setUserData(visitorSession.$state as any)
    }
  } catch (e: any) {
    console.log('middleware one error catched', e)
    if (!useIsBrowser()) {
      const visitorSession = useVisitorSession()
      return { path: `/dashboard/${visitorSession.user_id}`, query: to.query }
    }
    useFullscreenLoading().close()
    useDialog().alert({
      title: `获取用户 ${to.params.userId || to.query.asUser} 信息失败 ${JSON.stringify(e?.data?.message || e)}.`,
      description: '请重试。',
      confirmButtonText: '知道了',
    })
    if (from.fullPath !== to.fullPath) {
      return from
    }
    abortNavigation()
  }
})
